
import NameAvatar from '@/components/NameAvatar.vue'
import { RouteName, routes } from '@/router/index'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  components: {
    NameAvatar,
  },
})
export default class App extends Vue {
  routes = routes
  routeName = ''
  showSnackbar = false
  snackbarText = ''
  isErrorSnackbar = false

  get dark(): boolean {
    return this.$vuetify.theme.dark
  }

  set dark(value: boolean) {
    this.$vuetify.theme.dark = value
  }

  created(): void {
    this.$destroy = this.$store.subscribeAction(action => {
      if (action.type === 'snackbar') {
        this.showSnackbar = false
        this.$nextTick(() => {
          this.isErrorSnackbar = action.payload.isError
          this.snackbarText = `${action.payload.message}`
          this.showSnackbar = true
        })
      }
    })
  }

  signOut(): void {
    this.$store.commit('signOut')
    this.$router.push({ name: RouteName.signIn })
  }
}
